import { useQuery } from "hooks/useQuery";
import { getAllStrategyHoldings } from "features/Strategy/service";

export const useAllStrategyHoldings = (strategyId) => {
  return useQuery({
    key: "allStrategyHoldings",
    queryKey: ["allStrategyHoldings", strategyId],
    queryFn: async () => {
      const response = await getAllStrategyHoldings(strategyId);
      return response;
    },
    enabled: !!strategyId,
  });
};
